function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import SiteActivityTabs from "../../components/site-activity-tabs";
import { withRouter } from "react-router";
//import Chart from "../../components/chart";
import { ActivityContainer, ActivityTrendsHeader } from "../../components/container-activity";
import { SimpleContainer, CssContainer } from "../../components/container";
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import ActivityProductGrid from "../../components/activity-product-grid";
import { Loader, EllipsisLoader, ChartLoader } from '../../components/loaders';
import Error from '../../components/error';
import Query from "../../functions/query";
import rangeLabel from "../../functions/range-label";
import compLabel from "../../functions/comp-label";
import ServiceFactory from '../../service';
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import processProductUrls from "../../functions/process-product-urls";
import columnChartOptions from "../../settings/column-chart-options";
import GroupFilter from "../../components/group-filter";
import ActivityProductLocationGrid from "../../components/activity-product-location-grid";
import groupByLabel from "../../functions/groupBy-label";
import snakeToCamel from "../../functions/snake-to-camel";
import { Chart, ChartTitle, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartLegend, ChartTooltip, ChartValueAxis, ChartValueAxisItem } from '@progress/kendo-react-charts';
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onPageRequest", page => {
      //this.props.history.push(page);
      this.gotoPage(page);
    });
    _defineProperty(this, "onSelected", e => {
      var item = e.detail.item;
      var range = item.dataset.value;
      var comp = this.comp;
      this.fetchChartData = true;
      var redirectUrl = this.redirectUrl(range, comp);
      this.gotoPage(redirectUrl);
    });
    _defineProperty(this, "onCompSelected", e => {
      var item = e.detail.item;
      var range = this.range;
      var comp = item.dataset.value;
      if (comp === 'unavailable') {
        return;
      }
      this.fetchChartData = true;
      var redirectUrl = this.redirectUrl(range, comp);
      this.gotoPage(redirectUrl);
    });
    _defineProperty(this, "onProductLocationGroupBySelected", e => {
      var item = e.detail.item;
      var groupBy = item.dataset.value;
      var range = this.range;
      var comp = this.comp;
      console.log(groupBy);
      this.gotoPage(`/Activity/Product/Location/${range}/${comp}/${groupBy}`);
    });
    this.fetchChartData = false;
    this.state = {
      showLoader: true,
      productNames: [],
      productViews: [],
      productTitles: []
    };
  }
  async componentDidMount() {
    publishSearch('Product', true, 'product', 'title', 'Title');
    publishEvent('reset-search', {});
    await this.fetch();
    this._periodTok = subscribePeriod(({
      range,
      comp
    }) => {
      if (window.location.pathname.indexOf('/Activity/Product') !== 0) return;
      const r0 = range || getGlobalRange();
      const r = String(r0).indexOf('custom') === 0 ? 'this_month' : r0;
      const c = comp || this.comp;
      this.gotoPage(`/Activity/Product/${r}/${c}`);
    });
  }
  componentWillUnmount() {
    unsubscribePeriod(this._periodTok);
  }
  async componentDidUpdate() {
    console.log('update');
    if (this.fetchChartData) {
      await this.fetch();
    }
  }
  get isLocationView() {
    var path = location.pathname;
    path = path.toLowerCase();
    return path.includes('/location');
  }
  get defaultPage() {
    var isLocationView = this.isLocationView;
    if (!isLocationView) return this.page;else return 1;
  }
  get placesPage() {
    var isLocationView = this.isLocationView;
    if (isLocationView) return this.page;else return 1;
  }
  get range() {
    var range = this.props.params.range;
    if (!range) range = getGlobalRange();
    if (String(range).indexOf('custom') === 0) range = 'this_month';
    return range;
  }
  get comp() {
    var comp = this.props.params.comp;
    if (!comp) comp = getGlobalComp();
    return comp;
  }
  get compRange() {
    var range = this.range;
    var comp = this.comp;
    if (comp === 'prev_period') {
      range += '_prev';
    }
    return range;
  }
  get groupBy() {
    var groupBy = this.props.params.groupBy;
    if (!groupBy) groupBy = 'city';
    return groupBy;
  }
  get hideComp() {
    return this.range === 'all_time';
  }
  get baseUrl() {
    var range = this.range;
    var comp = this.comp;
    return `/Activity/Product/${range}/${comp}`;
  }
  get productLocationBaseUrl() {
    var range = this.range;
    var comp = this.comp;
    return `/Activity/Product/${range}/${comp}`;
  }
  get refreshUrl() {
    return `/Activity/Product/this_month/prev_year`;
  }
  get productLocationRefreshUrl() {
    return `/Activity/Product/Location/this_month/prev_year/city`;
  }
  redirectUrl(range, comp) {
    var groupBy = this.groupBy;
    if (this.isLocationView) {
      return `/Activity/Product/Location/${range}/${comp}/${groupBy}`;
    } else {
      return `/Activity/Product/${range}/${comp}`;
    }
  }
  async fetch() {
    //await this.fetchData();
    let {
      views,
      names,
      titles
    } = await this.fetchData();
    this.fetchChartData = false;
    this.setState({
      showLoader: false,
      productViews: views,
      productNames: names,
      productTitles: titles
    });
  }
  async fetchData() {
    var api = '/metrics/product/' + this.range;
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    try {
      let data = await service.paginate({
        baseUrl: '',
        rawUrl: location.href,
        page: 1,
        pageSize: 10
      }).orderByDesc('Views').getAsync();
      var items = data.items;
      return processProductUrls.processStats2(items);
      //var chartData = processProductUrls.processStats(items);
      //this.fetchChartData = false;
      //this.setState({ showLoader: false, chartData: chartData });
    } catch (err) {}
  }
  render() {
    var range = this.range;
    var groupBy = this.groupBy;
    var groupByColumn = snakeToCamel(groupBy);
    var baseUrl = this.baseUrl;
    var refreshUrl = this.refreshUrl;
    var productLocationBaseUrl = this.productLocationBaseUrl;
    var productLocationRefreshUrl = this.productLocationRefreshUrl;
    var data = this.props.data;
    var columnChartOpts1 = columnChartOptions();
    columnChartOpts1.hAxis.title = 'Title';
    columnChartOpts1.vAxis.title = 'Views';
    var selection = rangeLabel(range);
    var groupLabel = groupByLabel(groupBy);
    var compSelection = compLabel(this.comp);
    var compHide = range === 'all_time';
    //console.log(groupLabel);
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SiteActivityTabs, null), /*#__PURE__*/React.createElement(ActivityContainer, null, /*#__PURE__*/React.createElement(ActivityTrendsHeader, {
      title: "Top 10 Product Performance",
      hideControls: true,
      id: "product",
      selection: selection,
      onSelected: this.onSelected,
      compId: "product-comp",
      onCompSelected: this.onCompSelected,
      compSelection: compSelection,
      comp: this.comp,
      range: range,
      compHide: compHide
    }), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "body zero-top-padding"
    }, this.state.showLoader ? /*#__PURE__*/React.createElement(EllipsisLoader, {
      cls: "loader-container auto"
    }) : /*#__PURE__*/React.createElement(Chart, null, /*#__PURE__*/React.createElement(ChartCategoryAxis, null, /*#__PURE__*/React.createElement(ChartCategoryAxisItem, {
      categories: this.state.productNames,
      labels: {
        rotation: -45,
        content: e => {
          // Insert line break after every 2 words
          const parts = e.value.split(" ");
          if (parts.length <= 2) return e.value;
          const midpoint = Math.ceil(parts.length / 2);
          return parts.slice(0, midpoint).join(" ") + "\n" + parts.slice(midpoint).join(" ");
        }
      }
    })), /*#__PURE__*/React.createElement(ChartSeries, null, /*#__PURE__*/React.createElement(ChartSeriesItem, {
      type: "column",
      data: this.state.productViews,
      name: "Views",
      color: "#fa7d00",
      labels: {
        visible: true,
        position: "top",
        // Options: "center", "insideEnd", "outsideEnd", "top"
        content: e => e.value
      }
    })), /*#__PURE__*/React.createElement(ChartTooltip, null)))), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, "Product"))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityProductGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: data,
      pagination: this.props.pagination,
      comparison: this.props.comparison,
      onPageRequest: this.onPageRequest
    })), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GroupFilter, {
      id: "groupBy-filter-3",
      name: "Product Location: ",
      color: "orange",
      selection: groupLabel,
      onSelected: this.onProductLocationGroupBySelected
    }))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityProductLocationGrid, {
      refreshUrl: productLocationRefreshUrl,
      baseUrl: productLocationBaseUrl,
      data: this.props.productLocationData,
      comparison: this.props.productLocationComparison,
      range: range,
      column: groupByColumn,
      pagination: this.props.productLocationPagination,
      onPageRequest: this.onPageRequest
    })));
  }
}
export class ActivityProductViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  get isLocationView() {
    var path = location.pathname;
    path = path.toLowerCase();
    return path.includes('/location');
  }
  get defaultPage() {
    var isLocationView = this.isLocationView;
    if (!isLocationView) return this.page;else return 1;
  }
  get pagesLocationPage() {
    var isLocationView = this.isLocationView;
    if (isLocationView) return this.page;else return 1;
  }
  get range() {
    var range = this.props.params.range;
    if (!range) range = getGlobalRange();
    if (String(range).indexOf('custom') === 0) range = 'this_month';
    return range;
  }
  get comp() {
    var comp = this.props.params.comp;
    if (!comp) comp = getGlobalComp();
    return comp;
  }
  get compRange() {
    var range = this.range;
    var comp = this.comp;
    if (comp === 'prev_period') {
      range += '_prev';
    }
    return range;
  }
  get groupBy() {
    var groupBy = this.props.params.groupBy;
    if (!groupBy) groupBy = 'city';
    return groupBy;
  }
  get api() {
    var range = this.range;
    var api = `/metrics/product/${range}`;
    var where = this.where;
    if (!this.isLocationView && where) {
      api += '?$where=' + where;
    }
    return api;
  }
  get productLocationApi() {
    var groupBy = this.groupBy;
    var range = this.range;
    var api = `/metrics/product-location/${range}/${groupBy}`;
    var where = this.where;
    if (this.isLocationView && where) {
      api += '?$where=' + where;
    }
    return api;
  }
  get comparisonApi() {
    var compRange = this.compRange;
    var api = `/metrics/trends/product-stats/${compRange}`;
    return api;
  }
  get comparisonProductLocationApi() {
    var groupBy = this.groupBy;
    var compRange = this.compRange;
    var api = `/metrics/trends/product-location-stats/${compRange}/${groupBy}`;
    return api;
  }
  get baseUrl() {
    var range = this.range;
    var comp = this.comp;
    return `/Activity/Product/${range}/${comp}`;
  }
  get productLocationBaseUrl() {
    var range = this.range;
    var comp = this.comp;
    var groupBy = this.groupBy;
    var baseUrl = `/Activity/Product/Location/${range}/${comp}/${groupBy}`;
    return baseUrl;
  }
  get orderBy() {
    let query = this.queryParams;
    let orderBy = query.get('$orderBy');
    return orderBy;
  }
  get orderByDesc() {
    let query = this.queryParams;
    let orderBy = query.get('$orderBy');
    let orderByDesc = query.get('$orderByDesc');
    if (!orderBy && !orderByDesc) {
      orderByDesc = 'Views';
    }
    return orderByDesc;
  }
  get defaultOrderBy() {
    if (!this.isLocationView) {
      return this.orderBy;
    } else {
      return null;
    }
  }
  get defaultOrderByDesc() {
    if (!this.isLocationView) {
      return this.orderByDesc;
    } else {
      return 'Views';
    }
  }
  get productLocationOrderBy() {
    if (this.isLocationView) {
      return this.orderBy;
    } else {
      return null;
    }
  }
  get productLocationOrderByDesc() {
    if (this.isLocationView) {
      return this.orderByDesc;
    } else {
      return 'Views';
    }
  }
  get where() {
    let query = this.queryParams;
    let where = query.get('$where');
    return where;
  }
  async fetchData() {
    let page = this.defaultPage;
    let productPage = this.pagesLocationPage;
    var groupBy = this.groupBy;
    var groupByColumn = snakeToCamel(groupBy);
    var api = this.api;
    var comparisonApi = this.comparisonApi;
    var productLocationApi = this.productLocationApi;
    var comparisonProductLocationApi = this.comparisonProductLocationApi;
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    var ComparisonService = ServiceFactory.getType(comparisonApi);
    var comparisonService = new ComparisonService();
    var ProductLocationService = ServiceFactory.getType(productLocationApi);
    var productLocationService = new ProductLocationService();
    var ProductLocationComparisonService = ServiceFactory.getType(comparisonProductLocationApi);
    var productLocationComparisonService = new ProductLocationComparisonService();
    var baseUrl = this.baseUrl;
    var productLocationBaseUrl = this.productLocationBaseUrl;
    var defaultOrderBy = this.defaultOrderBy;
    var defaultOrderByDesc = this.defaultOrderByDesc;
    var productLocationOrderBy = this.pagesLocationOrderBy;
    var productLocationOrderByDesc = this.pagesLocationOrderByDesc;
    try {
      let data = await service.paginate({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: 10
      }).orderBy(defaultOrderBy).orderByDesc(defaultOrderByDesc).getAsync();
      console.log(data);
      let productLocationData = await productLocationService.paginate({
        baseUrl: productLocationBaseUrl,
        rawUrl: location.href,
        page: productPage,
        pageSize: 10
      }).orderBy(productLocationOrderBy).orderByDesc(productLocationOrderByDesc).getAsync();
      console.log(productLocationData);
      let comparison = [];
      let productLocationComparison = [];
      if (this.range !== 'all_time') {
        let skus = data.items.map(a => a.productId);
        comparison = await comparisonService.postAsync(skus);
        comparison.sort((a, b) => {
          return skus.findIndex(x => x === a.productId) - skus.findIndex(x => x === b.productId);
        });
        let productLocationColumnValues = productLocationData.items.map(a => a[groupByColumn]);
        productLocationComparison = await productLocationComparisonService.postAsync(productLocationColumnValues);
        productLocationComparison.sort((a, b) => {
          return productLocationColumnValues.findIndex(x => x === a[groupByColumn]) - productLocationColumnValues.findIndex(x => x === b[groupByColumn]);
        });
      }
      this.data = data.items;
      this.pagination = data.pagination;
      this.productLocationData = productLocationData.items;
      //this.productLocationData=[];
      this.productLocationPagination = productLocationData.pagination;
      //this.productLocationPagination={pages:[]};
      this.comparison = comparison;
      this.productLocationComparison = productLocationComparison;
      //this.productLocationComparison=[];
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
      window.scrollTo(0, 0);
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        params: this.props.params,
        comparison: this.comparison,
        productLocationData: this.productLocationData,
        productLocationPagination: this.productLocationPagination,
        productLocationComparison: this.productLocationComparison
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  ActivityProductViewComponent
};